import { trim } from 'ramda';

export const normalizePatiendId = (value, previousValue) => {
  if (!value) {
    return value;
  }

  const clearedValue = value.replace(/[-]/g, '');

  if (!previousValue || value.length > previousValue.length) {
    if (clearedValue.length === 2) {
      return `${clearedValue}-`;
    }
  }

  if (clearedValue.length <= 2) {
    return clearedValue;
  }

  return `${clearedValue.slice(0, 2)}-${clearedValue.slice(2)}`;
};

export const normalizePhone = value => {
  if (!value) {
    return value;
  }
  const clearedValue = value.replace(/\D/g, '');

  if (value[0] === '+') {
    return trim(
      `+${clearedValue.slice(0, 1)} ${clearedValue.length > 1 ? '(' : ''}${clearedValue.slice(
        1,
        4,
      )}${clearedValue.length > 4 ? ')' : ''} ${clearedValue.slice(4, 7)} ${clearedValue.slice(
        7,
        11,
      )}`,
    );
  }

  return trim(
    `${clearedValue.length > 0 ? '(' : ''}${clearedValue.slice(0, 3)}${
      clearedValue.length > 3 ? ')' : ''
    } ${clearedValue.slice(3, 6)} ${clearedValue.slice(6, 10)}`,
  );
};
